import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import getActivityFeed from '@api/activity-feed';
import { ApiResponse } from '@typings/ApiResponse';
import { ActivityResponseData, ActivityData } from '@typings/ActivityTypes';
import Pagination from '../pagination';

interface CarehomeActivitiesProps {
  partnerCarehomeId: string;
}

const CarehomeActivities: React.FC<CarehomeActivitiesProps> = ({
  partnerCarehomeId,
}) => {
  const [activityFeed, setActivityFeed] = useState<ActivityData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleGetActivityFeed = async () => {
      setLoading(true);
      try {
        const response: ApiResponse<ActivityResponseData> =
          await getActivityFeed(partnerCarehomeId, currentPage, 10);
        if (response && response.status === 'success') {
          setActivityFeed(response.data.data);
          setTotalPages(response.data.pages);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    if (partnerCarehomeId) {
      handleGetActivityFeed();
    }
  }, [partnerCarehomeId, currentPage]);
  return (
    <div>
      <h1 className="govuk-heading-l homepage-acp-title py-2 px-3">
        Activity Feed
      </h1>
      <table className="govuk-table">
        <tbody className="govuk-table__body">
          {activityFeed.map((acti: ActivityData) => {
            return (
              <tr className="govuk-table__row" key={acti.id}>
                <td className="govuk-table__cell govuk-!-width-three-quarters govuk-!-padding-left-2">
                  <h3 className="govuk-heading-s">{acti.description}</h3>
                  <p className="govuk-body">{acti.details.sub_description}</p>
                </td>
                <td className="govuk-table__cell govuk-!-width-one-quarter govuk-!-padding-right-2">
                  {dayjs(acti.created_at).format('h:mm A, D MMMM, YYYY')}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </div>
  );
};

export default CarehomeActivities;
